export default {
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    newPasswordConfirmation: 'New Password Confirmation',
    passwordMismatch: 'Passwords do not match',
    title: 'Change Your Password',
};
